import { Message } from 'element-ui';
import clone from 'clone';

import Vue from "vue"
/** 复制粘贴 */
export class CopyTable {
  constructor(e, tableData, rowIndex, columnIndex, props, noWrites,tableColumn) {
    console.error('rowIndex', tableData, rowIndex, columnIndex, props, noWrites)

    this.tableData = JSON.parse(JSON.stringify(tableData))
    this.columnIndex = columnIndex
    this.rowIndex = rowIndex
    this.$set = Vue.set
    this.props = props || null
    this.props._add = null
    this.tableColumn = tableColumn
    this.props._is_child = null
    this.props._form_id = null
    this.props.expanded = null
    this.props._children = null
    this.noWrites=noWrites||[]
    this.pasteInfo(e)
  }
  // 处理对象内部的字段 按顺序
  initObj(editObj) {
    const keys = Object.keys(editObj || this.props)
    let emptyObj = {}
    let origin = editObj ? { ...editObj } : {}
    keys.map(it => {
      emptyObj[it] = editObj ? origin[it] : null
    })
    return emptyObj
  }
  pasteInfo(e) {
    try {
      e.preventDefault(); //阻止默认粘贴事件
      e.stopPropagation(); //阻止事件冒泡
      let data = null, clipboardData = e.clipboardData || window.clipboardData; // IE
      if(!clipboardData) clipboardData = e.originalEvent.clipboardData;
      data = clipboardData.getData("Text"); //复制过来的内容
      //首先对源头进行解析
      //单独复制文本，不是复制单个单元格
      if(data && !data.includes('\r\n')) data = data + '\r\n';
      let rowStrArray = data.split("\r\n"), rows = []; //拆成多行
      for(let i = 0; i < rowStrArray.length - 1; i++) {
        let row = [], tdStrArray = rowStrArray[i].split("\t"); //按列拆分
        for(let j = 0; j < tdStrArray.length; j++) {
          row.push(tdStrArray[j]);
        }
        rows.push(row);
      }
      let emptyObj = this.initObj(this.tableData[this.rowIndex])
      const current = this.tableData[this.rowIndex]
      // 可能会有数据 给空对象复制
      for(let j = 0; j < rows.length; j++) {
        let item = {}, num = 0, numFlag = 0
        if (this.rowIndex + j > this.tableData.length - 1) {
          this.tableData.push(this.initObj(null))
        } else {
          item = this.initObj(this.tableData[this.rowIndex + j])
          console.error('item', item)
        }
        for (let index = 0; index < this.tableColumn.length; index++) {
          const key = this.tableColumn[index]
          if(!rows[j][num] &&rows[j][num]!=="") {
            break
          }
          if(this.columnIndex <= numFlag) {
            // 针对不能修改的列字段做处理，可以复制粘贴的列才做赋值。根据需求加下面的if判断
            if(!this.noWrites.includes(key)){
              item[key] = rows[j][num]
            }
            num = num + 1
          }
          numFlag = numFlag + 1
        }
        this.$set(this.tableData, this.rowIndex + j, item)
      }
    } catch (err) {
      console.log(err)
      Message.error('请选择粘贴位置')
    }
  }
}

//  @paste.native="(e)=>parent.vueInst().$copyVxeTable(e,getTableRef(),rowIndex,columnIndex-2)"

//  复制el-table的相关业务逻辑
export const copyElTable = (e, data, rowIndex, columnIndex) => {
  console.error('copyElTable1')
  const { tableData } = new CopyTable(e, data, rowIndex, columnIndex)
  return tableData
}
export const copyVxeTable = (e, table, rowIndex, columnIndex,copyConfig) => {
  console.error('copyElTable2')
  if(!copyConfig.able){
    return false
  }
  // console.log(e)
  // return
  table.createRow().then(res => {
    const data = table?.getTableData()?.fullData
    if (data.length) {
      const { tableData } = new CopyTable(e, data, rowIndex, columnIndex, res,copyConfig.ignoreArr, copyConfig.tableColumn)
      table.reloadData(tableData)
      console.log(tableData)
      return tableData

    }
  })
}
